import * as Yup from "yup";
import MESSAGE from "~/utils/messages";
import {
  phoneDDDValidation,
  phoneWithOutDDDValidation,
} from "~/utils/tools";

function equalTo(ref, msg) {
  return Yup.mixed().test({
    name: "equalTo",
    exclusive: false,
    message: msg || MESSAGE.genericError,
    params: {
      reference: ref.path,
    },
    test: function(value) {
      return value === this.resolve(ref);
    },
  });
}
Yup.addMethod(Yup.string, "equalTo", equalTo);

export const schema = Yup.object().shape({
  Instagram: Yup.string()
    .matches(
      /^@[a-zA-Z0-9._]{1,49}$/,
      MESSAGE.invalidInstagram
    )
    .required(MESSAGE.requiredField),
  Cep: Yup.string().required(MESSAGE.requiredField),
  Endereco: Yup.string().required(MESSAGE.requiredField),
  Numero: Yup.string ()
    .matches(/^[0-9]+$/, MESSAGE.invalidNumber)
    .required(MESSAGE.requiredField),
  Complemento: Yup.string(),
  Cidade: Yup.string().required(MESSAGE.requiredField),
  Bairro: Yup.string().required(MESSAGE.requiredField),
  Estado: Yup.object().shape({
    label: Yup.string().required(MESSAGE.requiredSelect),
    value: Yup.string().required(MESSAGE.requiredSelect),
    id: Yup.number().required(MESSAGE.requiredSelect),
  }),
  TelefoneTipo: Yup.object().shape({
    label: Yup.string().required(MESSAGE.requiredSelect),
    value: Yup.string().required(MESSAGE.requiredSelect),
    id: Yup.number().required(MESSAGE.requiredSelect),
  }),
  DDDTelefone: Yup.mixed()
    .required(MESSAGE.requiredCheck)
    .test({
      name: "DDDTelefone",
      message: MESSAGE.invalidDDD,
      test: (value) => {
        if (value) {
          return phoneDDDValidation(value);
        }
        return false;
      },
    }),
  Telefone: Yup.mixed()
    .required(MESSAGE.requiredCheck)
    .test({
      name: "Telefone",
      message: MESSAGE.invalidPhone,
      test: (value) => {
        if (value) {
          return phoneWithOutDDDValidation(value);
        }
        return false;
      },
    }),
  AceitaTermosLegais: Yup.array()
    .of(Yup.string())
    .required(MESSAGE.requiredCheck),
  AceitaRegulamento: Yup.array()
    .of(Yup.string())
    .required(MESSAGE.requiredCheck),
  AceitaReceberNoticias: Yup.array()
    .of(Yup.string())
    .required(MESSAGE.requiredCheck),
  AceitaPoliticaDePrivacidade: Yup.array()
    .of(Yup.string())
    .required(MESSAGE.requiredCheck),
});
